import { render, staticRenderFns } from "./ConsentLedgerView.vue?vue&type=template&id=11266e21&scoped=true&"
import script from "./ConsentLedgerView.vue?vue&type=script&lang=js&"
export * from "./ConsentLedgerView.vue?vue&type=script&lang=js&"
import style0 from "./ConsentLedgerView.vue?vue&type=style&index=0&id=11266e21&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11266e21",
  null
  
)

export default component.exports